import { render, staticRenderFns } from "./PendingSimulationExamModalComponent.vue?vue&type=template&id=1c49310c&scoped=true&"
import script from "./PendingSimulationExamModalComponent.vue?vue&type=script&lang=js&"
export * from "./PendingSimulationExamModalComponent.vue?vue&type=script&lang=js&"
import style0 from "./PendingSimulationExamModalComponent.vue?vue&type=style&index=0&id=1c49310c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c49310c",
  null
  
)

export default component.exports